import React from "react";
import { LucideIcon, TrendingUp, TrendingDown, Minus } from "lucide-react";

interface KPICardProps {
  icon: LucideIcon;
  label: string;
  value: number | string;
  color?: string;
  trend?: number; // positive = up, negative = down, 0 = neutral
  subLabel?: string;
}

export default function KPICard({
  icon: Icon,
  label,
  value,
  color = "#65ADDD",
  trend,
  subLabel,
}: KPICardProps) {
  const iconBg = `${color}20`; // 12% opacity version of the color

  return (
    <div className="card p-4 md:p-6 flex flex-col gap-3 hover:shadow-md transition-shadow duration-200 min-h-[44px]">
      <div className="flex items-start justify-between">
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: iconBg }}
        >
          <Icon size={20} style={{ color }} />
        </div>
        {trend !== undefined && (
          <div
            className={`flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${
              trend > 0
                ? "bg-green-50 text-green-700"
                : trend < 0
                ? "bg-red-50 text-red-600"
                : "bg-slate-100 text-slate-500"
            }`}
          >
            {trend > 0 ? (
              <TrendingUp size={12} />
            ) : trend < 0 ? (
              <TrendingDown size={12} />
            ) : (
              <Minus size={12} />
            )}
            {Math.abs(trend)}%
          </div>
        )}
      </div>

      <div>
        <div className="text-2xl md:text-3xl font-bold text-slate-800 leading-tight">
          {value}
        </div>
        <div className="text-sm font-medium text-slate-500 mt-0.5">{label}</div>
        {subLabel && <div className="text-xs text-slate-400 mt-1">{subLabel}</div>}
      </div>
    </div>
  );
}
